import { focusTopic } from '@/mocks/home';

export default function FocusWeekly() {
  return (
    <section id="focus" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="w-full max-w-[1180px] mx-auto">
        <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="lg:col-span-3 p-6 md:p-9">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-accent-100 text-accent-800 text-xs md:text-sm">
                <i className="ri-article-line"></i>
                {focusTopic.week} · 编辑组周报
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                {focusTopic.title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {focusTopic.desc}
              </p>

              <ul className="mt-6 flex flex-col gap-3">
                {focusTopic.points.map((point) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="mt-0.5 w-5 h-5 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className="text-xs md:text-sm text-foreground-700 leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-7 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-background-300/60 pt-6">
                {focusTopic.meta.map((item) => (
                  <div key={item.id} className="flex flex-col gap-1">
                    <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                      {item.value}
                    </span>
                    <span className="text-xs text-foreground-500">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-2 relative min-h-[240px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20stacked%20newspapers%20and%20tangled%20red%20threads%20on%20a%20warm%20cream%20background%2C%20muted%20crimson%20and%20sage%20green%20accents%2C%20minimal%20geometric%20shapes%2C%20soft%20grain%20texture%2C%20calm%20artistic%20composition%2C%20no%20text&width=1200&height=1000&seq=gossip-focus-week-02&orientation=portrait"
                alt="吃瓜黑料网 本周焦点 板块更新汇总"
                title="吃瓜黑料网 本周焦点 板块更新汇总"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent"></div>
              <div className="absolute left-5 bottom-5 right-5 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-[11px] md:text-xs text-foreground-800">
                  配图：编辑组周报主视觉
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}